import {
  MESSAGE_CHANNELS_V3,
  type MessageChannelV3,
} from "@redotech/redo-flows-common/rules-v3/types";
import { t } from "@redotech/redo-i18n";
import type { RedoListItem } from "@redotech/redo-web/arbiter-components/list/redo-list";

export const channelDisplayNames = (): Record<MessageChannelV3, string> => ({
  gmail: "Gmail",
  outlook: "Outlook",
  customEmail: t("Custom Email"),
  redoChat: t("Chat"),
  facebook: "Facebook",
  facebookComments: t("{{integrationName}} Comments", {
    integrationName: "Facebook",
  }),
  instagram: "Instagram",
  instagramComments: t("{{integrationName}} Comments", {
    integrationName: "Instagram",
  }),
  sms: t("SMS"),
  voice: t("Voice"),
  attentive: "Attentive",
  postscript: "Postscript",
  tiktok: "TikTok",
  contactForm: t("Contact Form"),
});

export const channelItems = (): RedoListItem<MessageChannelV3>[] =>
  MESSAGE_CHANNELS_V3.map((channel) => ({
    id: channel,
    type: "text" as const,
    text: channelDisplayNames()[channel],
    value: channel,
  }));
